import { Component, inject } from '@angular/core';
import { BaseMainMenuComponent } from '../base/base-main-menu.component';
import { Router } from '@angular/router';

@Component({
  selector: 'lbt-main-menu',
  standalone: false,
  templateUrl: './main-menu.component.html',
  styleUrl: './main-menu.component.scss'
})
export class MainMenuComponent extends BaseMainMenuComponent {
  private readonly router = inject(Router);

  navigateToMainPage() {
    this.router.navigate(['']);
  }
}
